import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Banner, Flex, UiText } from '@shared/ui';
import { activateTab } from '@widgets/WidgetsShop/lib';

import cls from './WidgetShopBanner.module.css';

interface IWidgetShopBannerProps {
    className?: string;
}

export const WidgetShopBanner = ({ className }: IWidgetShopBannerProps) => {
    const { t } = useTranslation();
    const onActivate = () => activateTab('widgets-shop-tab');
    return (
        <Flex className={cn(cls.WidgetShopBannerContainer, className)} onClick={onActivate}>
            <Banner className={cls.banner} contentWrapperClassName={cls.bannerContentWrapper}>
                <Banner.Title>
                    <UiText variant="subHeading" weight="bold" className={cls.bannerTitle}>
                        {t('WidgetShop.Banner.title')}
                    </UiText>
                </Banner.Title>
                <Banner.Description>
                    <UiText>{t('WidgetShop.Banner.description')}</UiText>
                </Banner.Description>
            </Banner>
        </Flex>
    );
};
